<div class="error">
  <p>{{ errorMessage }}</p>
</div>